import React from 'react';

import { string, shape, bool, oneOfType, arrayOf, node } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../BaseComponent';

import './List.scss';

export default class List extends BaseComponent {
  constructor(props) {
    super(props);

    this.ref = React.createRef();
  }

  render() {
    const { children, id, style, className, dense, divider } = this.props;

    const classes = ['List', className, dense && 'dense', divider && 'divider'];

    const classNames = ClassNames(classes);

    return (
      <ul id={id} style={style} className={classNames} ref={this.ref}>
        {children}
      </ul>
    );
  }
}

List.propTypes = {
  id: string,
  style: shape({}),
  className: string,
  dense: bool,
  divider: bool,
  children: oneOfType([arrayOf(node), node])
};

List.defaultProps = {
  id: undefined,
  style: {},
  className: undefined,
  dense: false,
  divider: false
};
